import { render, staticRenderFns } from "./VButtonCarousel.vue?vue&type=template&id=0dbae5da&scoped=true"
import script from "./VButtonCarousel.vue?vue&type=script&lang=ts"
export * from "./VButtonCarousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbae5da",
  null
  
)

export default component.exports